module.exports = __webpack_public_path__ + "media/src/images/icons/gray-chevron-down-9c14306a4f737d4ad2e4f656411d05e3.svg";